// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1JFWY","insightsList":"newBusinessInsightsMenu_insightsList__3VY0i","active":"newBusinessInsightsMenu_active__2Z-s0"};